import { compose, pure } from 'recompose';
import React, { useState, useEffect } from 'react';
import { PremiumIcon } from '@angi/icons';
import PremiumLeadsRange, { MIN } from './PremiumLeadsRange';
import EstimatedLeads from './EstimatedLeads';
import { expectedLeadsByCategoryGroupIdMap } from './data/categories-estimated-lead-count';
import './LeadsCalculator.scss';
import {
  ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL,
  ONLINE_UPGRADE_OFFER_ZERO_DOLLAR_ETF,
} from '../../../../common/commonConstants';

type Props = {
  categoryGroupId: number;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  premiumUrl: string;
  upgradeUrl: string;
  onlineUpgradeOffer:string;
  hideComponent: boolean;
};

const LeadsCalculator = ({
  categoryGroupId,
  showModal,
  setShowModal,
  premiumUrl,
  upgradeUrl,
  onlineUpgradeOffer,
  hideComponent,
}: Props): Node => {
  const [value, setValue] = useState(MIN);
  const [header, setHeader] = useState('Want more leads?');
  const [subHeader, setSubHeader] = useState('Upgrade to get consistent leads within a monthly budget you choose.');
  const estimates = expectedLeadsByCategoryGroupIdMap[categoryGroupId].expectedLeadsByBudgetMap;

  if (!estimates || hideComponent) {
    return null;
  }

  useEffect(() => {
    if (onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL) {
      setHeader('Get a month of free leads.');
      setSubHeader('Only pay for a $50 background check. An online exclusive - cancel any time.');
    } else if (onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_ZERO_DOLLAR_ETF) {
      setHeader('Grow faster with Angi Premium.');
      setSubHeader('Set a custom monthly lead budget (from $200/mo). Cancel for free, any time.');
    }
  }, [onlineUpgradeOffer]);

  return (
    <div className="leads-calculator-inner-container">
      { (onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL) && (
      <div className="row premium-check">
        <div className="icon-container">
          <PremiumIcon className="premium-check-icon" />
        </div>
        <span>ANGI ADS</span>
      </div>
      )}
      <h2 className="leads-calculator-header headline-xl headline-3xl National2-Bold">
        { header }
      </h2>
      <p className="leads-calculator-subheader">
        { subHeader }
      </p>
      <div className="leads-calculator-info-container">
        <PremiumLeadsRange
          value={value}
          setValue={setValue}
          onlineUpgradeOffer={onlineUpgradeOffer}
        />
        <div className="divider-line" />
        <EstimatedLeads
          value={value}
          showModal={showModal}
          setShowModal={setShowModal}
          estimates={estimates}
          premiumUrl={onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL ?
            upgradeUrl : premiumUrl}
          onlineUpgradeOffer={onlineUpgradeOffer}
        />
      </div>
    </div>
  );
};


export default (compose(pure)(LeadsCalculator): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/LeadsCalculator.js